//import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { ConfigProvider } from '../config/config'
import { DeviceProvider } from '../device/device'
import { Events } from 'ionic-angular'
import { DomainEvents, Device } from '../../models/models'

declare var ImageCapture: any

@Injectable()
export class SecurityCamProvider {
	private takePhotoTimeout = null;
	private isEnabled: boolean = false;

	constructor(
		private devices: DeviceProvider,
		private events: Events) {
		let self = this

		/*
		listener del dispositivo attuale,
		se è citofono o bacheca scatta una foto ogni X secondi
		*/
		//TODO la mette in una cartella, rimuovendo le foto più vecchie di 24 ore
		self.events.subscribe(DomainEvents.DEVICE_ACTUAL_UPDATED, (device: Device, time, previous: Device) => {
			if(device && device.is_security_cam_enabled) {
				console.debug('Configurazione dispositivo aggiornata, security cam attiva sul dispositivo')
				if(!self.devices.isVideoInputSupported) {
					console.warn('Security cam attiva sul dispositivo, ma nessun dispositivo di ingresso video disponibile')
					this.disable()
					return
				}
				this.enable()
			} else {
				this.disable()
			}
		})
	}

	public disable() {
		console.log('Disattivazione security cam')
		if(this.takePhotoTimeout) {
			clearTimeout(this.takePhotoTimeout)
		}
		this.isEnabled = false
	}

	public enable() {
		console.log('Azzivazione security cam')
		if(this.takePhotoTimeout) {
			console.log('Timeout security cam già attivo')
		} else {
			let self = this
			this.takePhotoTimeout = setTimeout(() => {
				try {
					self.takeFrame()
				} catch(e) {
					console.error('Errore prendendo il frame per security cam:', e)
				}
			}, ConfigProvider.TIMEOUT_SECURITY_CAM_FRAME * 1000)
		}
		this.isEnabled = true
	}

	private takeFrame() {
		if(!this.devices.isVideoInputSupported) {
			console.warn('SecurityCamProvider.takeFrame() : Security cam attiva ma nessun dispositivo di input video disponibile sul dispositivo corrente')
			return
		}

		console.debug('SecurityCamProvider.takeFrame() : Foto security cam..')
		navigator.mediaDevices.getUserMedia({ audio: false, video: true })
			.then(mediaStream => {
				if(!ImageCapture) {
					console.warn('ImageCapture non definito, impossibile scattare la foto.')
					return
				}
				const mediaStreamTrack = mediaStream.getVideoTracks()[0]
				const imageCapture = new ImageCapture(mediaStreamTrack)
				console.debug('ImageCapture:', imageCapture)

				//const img = document.querySelector('img');
				// ...
				imageCapture.takePhoto()
					.then(imageBlob => {
						console.log('Scattata foto, blob risultante:', imageBlob)
						let imgUrlencoded = URL.createObjectURL(imageBlob)
						console.log('Foto urlencoded:', imgUrlencoded)
						//img.onload = () => { URL.revokeObjectURL(this.src)
					}).catch(error => console.error('Errore ImageCapture.takePhoto():', error))

				/*
				imageCapture.grabFrame()
				  .then(imageBitmap => {
					canvas.width = imageBitmap.width;
					canvas.height = imageBitmap.height;
					canvas.getContext('2d').drawImage(imageBitmap, 0, 0);
				  })
				  .catch(error => console.error('grabFrame() error:', error));
				*/
			}).catch(error => console.error('Errore recuperando i dispositivi multimediali locali:', error))
	}
}



// WEBPACK FOOTER //
// ./src/providers/security-cam/security-cam.ts